import { render, staticRenderFns } from "./SelectPartners.vue?vue&type=template&id=094ee650&scoped=true&"
import script from "./SelectPartners.vue?vue&type=script&lang=js&"
export * from "./SelectPartners.vue?vue&type=script&lang=js&"
import style0 from "./SelectPartners.vue?vue&type=style&index=0&id=094ee650&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094ee650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
